import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
let BdpkObject = class BdpkObject extends DxGridRow {
    constructor() {
        super(...arguments);
        this.privileges = [];
    }
    get id() {
        return this.objectId;
    }
    /** показ кнопок на тулбаре */
    canExecuteToolbarAction(action) {
        switch (action.type) {
            case 'DOWNLOAD':
                return this.isFile;
            case 'START':
                return this.isRun;
            case 'OPEN':
                return !this.isFile;
            case 'SCHEDULE':
                return this.isSchedule;
        }
        return true;
    }
    get objectId() {
        return this._objectId;
    }
    set objectId(value) {
        this._objectId = value;
    }
    get folderId() {
        return this._folderId;
    }
    set folderId(value) {
        this._folderId = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get objectTypeName() {
        return this._objectTypeName;
    }
    set objectTypeName(value) {
        this._objectTypeName = value;
    }
    get createDate() {
        return this._createDate;
    }
    set createDate(value) {
        this._createDate = value;
    }
    get isFavorite() {
        return this._isFavorite;
    }
    set isFavorite(value) {
        this._isFavorite = value;
    }
    get filePath() {
        return this._filePath;
    }
    set filePath(value) {
        this._filePath = value;
    }
    get objectTypeId() {
        return this._objectTypeId;
    }
    set objectTypeId(value) {
        this._objectTypeId = value;
    }
    get createUserId() {
        return this._createUserId;
    }
    set createUserId(value) {
        this._createUserId = value;
    }
    get changeDate() {
        return this._changeDate;
    }
    set changeDate(value) {
        this._changeDate = value;
    }
    get changeUserId() {
        return this._changeUserId;
    }
    set changeUserId(value) {
        this._changeUserId = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get analyticalTaskId() {
        return this._analyticalTaskId;
    }
    set analyticalTaskId(value) {
        this._analyticalTaskId = value;
    }
    get objectTypeImagePath() {
        return this._objectTypeImagePath;
    }
    set objectTypeImagePath(value) {
        this._objectTypeImagePath = value;
    }
    get objectTypeDeTypeLink() {
        return this._objectTypeDeTypeLink;
    }
    set objectTypeDeTypeLink(value) {
        this._objectTypeDeTypeLink = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "objectId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_objectId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "folderId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_folderId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "analyticalTaskId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_analyticalTaskId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_objectTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectTypeImagePath", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_objectTypeImagePath", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectTypeName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_objectTypeName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "filePath", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_filePath", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkObject.prototype, "isFile", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkObject.prototype, "isRun", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkObject.prototype, "isSchedule", void 0);
tslib_1.__decorate([
    jsonMember({ name: "createDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkObject.prototype, "_createDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "createUserId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_createUserId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkObject.prototype, "_changeDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeUserId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_changeUserId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkObject.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isFavorite", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkObject.prototype, "_isFavorite", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectTypeDeTypeLink", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkObject.prototype, "_objectTypeDeTypeLink", void 0);
tslib_1.__decorate([
    jsonArrayMember(Number, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkObject.prototype, "privileges", void 0);
BdpkObject = tslib_1.__decorate([
    jsonObject
], BdpkObject);
export { BdpkObject };
